export default [
    {
        name: 'environmentMapTexture',
        type: 'cubeTexture',
        path:
        [
            'textures/environmentMap/test.png',
            'textures/environmentMap/test.png',
            'textures/environmentMap/test.png',
            'textures/environmentMap/test.png',
            'textures/environmentMap/test.png',
            'textures/environmentMap/test.png',
        ]
    },
    {
        name: 'lyricTexture',
        type: 'texture',
        path: 'textures/pictures/lyricDarker.png'
    },
]